import React, {useState} from "react";
import styles from "../styles/accountOverview.module.css";
import house from "../assets/svgs/house.svg";
import grnhouse from "../assets/svgs/grnhouse.svg"
import grnpen from "../assets/svgs/grnpen.svg"
import grnlock from "../assets/svgs/grnlock.svg"
import pen from "../assets/svgs/pen.svg";
import lock from "../assets/svgs/lock.svg"
import Footer from "../components/layout/Footer";
import MenuBar from "../components/menuBarLoggedIn/menuBarLoggedIn.jsx";
import AccountPage from "./AccountPage";
import EditProfile from "./EditProfile";
import  ChangePassword from "./ChangePassword";

const AccountOverview = () => {
  const [child1Visible, setChild1Visible] = useState(true);
  const [child2Visible, setChild2Visible] = useState(false);
  const [child3Visible, setChild3Visible] = useState(false);

  const toggleChild1Visibility = () => {
    if (!child1Visible) {
      setChild1Visible(!child1Visible);
      setChild2Visible(false);
      setChild3Visible(false);
    }
  };
  
  const toggleChild2Visibility = () => {
    if (!child2Visible) {
      setChild1Visible(false);
      setChild2Visible(!child2Visible);
    setChild3Visible(false);
    }
  };
  
  const toggleChild3Visibility = () => {
    if (!child3Visible) {
    setChild1Visible(false);
    setChild2Visible(false);
    setChild3Visible(!child3Visible);
    }
  };
  return (
    <div className={styles.mainWrapper}>
      
        <MenuBar />
        <div className={styles.AccountWrapper}>
        <header className={styles.accHead} >
            <div className={styles.AccountSelections}>
              <div className={styles.overviewBtn} onClick={toggleChild1Visibility}>
                
                {child1Visible && <img src={grnhouse} id={styles.clickedImg}/>}
                {child1Visible && <p className={styles.clickedText}> Account Overview</p>}
                

                {!child1Visible && <img src={house} id={styles.unclickedImg}/>}
                {!child1Visible && <p >Account Overview</p> }
                
              </div>
              <div className={styles.overviewBtn} onClick={toggleChild2Visibility}>
                {child2Visible && <img src={grnpen} id={styles.clickedImg}/>}
                {child2Visible && <p className={styles.clickedText}>Edit profile</p>}
                

                {!child2Visible && <img src={pen} className={styles.unclickedImg}/>}
                {!child2Visible && <p >Edit profile</p> }
                
                
              </div>
              <div className={styles.overviewBtn} onClick={toggleChild3Visibility}>

              {child3Visible && <img src={grnlock} />}
                {child3Visible && <p className={styles.clickedText}>Change password</p>}



                {!child3Visible && <img src={lock} className={styles.unclickedImg}/>}
                {!child3Visible && <p >Change password</p>}
              </div>
            </div>
          </header>
          <div className={styles.AccountOverviewPages}>
          {child1Visible && <AccountPage />}
          {child2Visible && <EditProfile/>}
          {child3Visible && <ChangePassword/>}
          </div>
          </div>
          <Footer/>
    </div>
  );
};

export default AccountOverview;
